module.exports = __webpack_public_path__ + "static/media/paso 3 bis.5e827032.png";